import React from 'react';
import { Tag } from 'antd';
import type { RouteOperationalCoordination } from './types';

export type CoordinationWorkspaceHintProps = {
  coordination: RouteOperationalCoordination | null | undefined;
};

/** Compact workspace tags — not a planning board. */
export const CoordinationWorkspaceHint: React.FC<CoordinationWorkspaceHintProps> = ({
  coordination
}) => {
  if (!coordination) return null;

  const tags: Array<{ key: string; color: string; label: string }> = [];

  if (coordination.vehicleChain.impactedNextCount > 0) {
    tags.push({
      key: 'chain',
      color: 'warning',
      label: `Цепочка: ${coordination.vehicleChain.impactedNextCount}`
    });
  }
  if (coordination.conflicts.hasConflict) {
    tags.push({ key: 'conflict', color: 'error', label: 'Конфликт' });
  }
  if (coordination.resourceOccupancy.pendingRoutesWaiting > 0) {
    tags.push({
      key: 'wait',
      color: 'processing',
      label: `Ожидают: ${coordination.resourceOccupancy.pendingRoutesWaiting}`
    });
  }
  if (coordination.cascade.hasCascadeRisk) {
    tags.push({ key: 'cascade', color: 'orange', label: 'Каскад' });
  }

  if (!tags.length) return null;

  return (
    <span className="execution-workspace__coordination-hints">
      {tags.map((t) => (
        <Tag key={t.key} color={t.color}>
          {t.label}
        </Tag>
      ))}
    </span>
  );
};

export default CoordinationWorkspaceHint;
